import { connect } from 'react-redux';

import ThreadListContainer from '../../MessagesTemplate/ThreadTemplate/ThreadListTemplateContainer';

import * as communitySelectors from '../selectors';

const CommunityCurrentMessageContainer = (props) => (
  <ThreadListContainer {...props} />
);

const mapStateToProps = (state) => {
  const chatMessages = communitySelectors.getCommunityCurrentChat(state);
  const nextChatMessages = state?.community?.currentChat?.next;
  return {
    chatMessages,
    nextChatMessages,
  };
};

export default connect(mapStateToProps, null)(CommunityCurrentMessageContainer);
